import i18n from "i18n";

const mainMenuItems = [
  {
    title: i18n.t("stock.sheet"),
    arrow: true,
    to: "/admin/ficha-de-stock",
    permission: 'read_orders',
  },
  {
    title: i18n.t("stock.audit"),
    arrow: true,
    to: "/admin/auditoria-de-stock",
    permission: 'auditory_stock',
  },
  {
    title: i18n.t("location.stock"),
    arrow: true,
    toStep: 1,
    permission: 'localization_stock',
  },
];

export const step0 = {
  items: mainMenuItems,
  headerTitle: i18n.t("stock"),
  navHidden: false,
  goBackTo: undefined,
};
